export default {"src":"/_next/static/media/google.7baef772.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};